import React from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Same tones as GoalStatusChip so buttons and pills read as one system.
const TONES = {
  success: { fg: "#0e7a2b", bg: "#e4f6e8", solid: "#17ad37" },
  warning: { fg: "#946200", bg: "#fff4d6", solid: "#f2b705" },
  error: { fg: "#c01616", bg: "#fde7e7", solid: "#ea0606" },
  info: { fg: "#0b7c99", bg: "#e0f5fb", solid: "#17c1e8" },
  secondary: { fg: "#4b5a73", bg: "#eef0f4", solid: "#67748e" },
};

// Soft-tinted square icon button with a hover tooltip: tinted fill at rest,
// solid colour with white icon and a slight lift on hover.
function GoalActionButton({ icon, tooltip, color, onClick, disabled }) {
  const tone = TONES[color] || TONES.secondary;

  return (
    <Tooltip title={tooltip} arrow>
      {/* span so the tooltip still shows on a disabled button */}
      <span>
        <IconButton
          size="small"
          aria-label={typeof tooltip === "string" ? tooltip : undefined}
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          sx={{
            width: 34,
            height: 34,
            borderRadius: "10px",
            color: tone.fg,
            backgroundColor: tone.bg,
            transition: "background-color 0.15s ease, color 0.15s ease",
            "&:hover": {
              backgroundColor: tone.solid,
              color: "#fff",
            },
            "&.Mui-disabled": { color: "#b4bccb", backgroundColor: "#f3f4f7" },
          }}
        >
          <Icon sx={{ fontSize: "18px !important" }}>{icon}</Icon>
        </IconButton>
      </span>
    </Tooltip>
  );
}

GoalActionButton.defaultProps = { color: "secondary", disabled: false };
GoalActionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  tooltip: PropTypes.node.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default GoalActionButton;
